var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.785755 6.71361L5.78575 11.7136C5.97339 11.9013 6.22789 12.0067 6.49325 12.0067C6.75862 12.0067 7.01311 11.9013 7.20075 11.7136C7.38839 11.526 7.49381 11.2715 7.49381 11.0061C7.49381 10.7407 7.38839 10.4863 7.20075 10.2986L2.90775 6.00561L7.20075 1.71261C7.29626 1.62037 7.37245 1.51002 7.42486 1.38802C7.47726 1.26601 7.50485 1.13479 7.506 1.00201C7.50716 0.869234 7.48186 0.737555 7.43158 0.614658C7.3813 0.491762 7.30704 0.38011 7.21315 0.286218C7.11926 0.192325 7.0076 0.118072 6.88471 0.067791C6.76181 0.0175101 6.63013 -0.00779234 6.49735 -0.00663853C6.36457 -0.00548471 6.23335 0.0221016 6.11135 0.0745106C5.98935 0.12692 5.879 0.203102 5.78675 0.298613L0.786755 5.29861C0.599284 5.48614 0.493968 5.74045 0.493968 6.00561C0.493968 6.27078 0.599284 6.52508 0.786755 6.71261L0.785755 6.71361Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.33f113240b6f8d8ce0b24bbef6551d0f.svg";
export { ForwardRef as ReactComponent };